// Function component (presentational):

import React from 'react'

import SectionWrapper from '../shared/styledComponents/page/SectionWrapper'
import SectionTitle from '../shared/styledComponents/page/SectionTitle'
import ContentWrapper from '../shared/styledComponents/page/ContentWrapper'
// import Illustration from '../shared/styledComponents/Illustration'

import Title from '../shared/styledComponents/text/Title'

import Card from '../shared/styledComponents/card/Card'

import renderLabel from '../shared/other/renderLabel'

import checkpoint2 from '../../assets/illustrations/onboarding/hiking.png'

import { FireOutlined, RightOutlined } from '@ant-design/icons'
import BlockRoundButton from '../shared/styledComponents/button/BlockRoundButton'

const OnboardingCheckpoint2 = ({ nextStep, t }) => (
	<SectionWrapper
	// id="onboarding-checkpoint2-wrapper"
	// $type="illustration"
	>
		<SectionTitle>
			<Title level={3}>{t('onboarding:checkpoint2.title')}</Title>
		</SectionTitle>

		<ContentWrapper style={{ alignItems: 'center' }}>
			<Card
				cover={
					<img
						src={checkpoint2}
						alt={t('onboarding:checkpoint2.illustration')}
						width="100%"
						height="100%"
					/>
				}
				$withMeta
			>
				<Card.Meta
					title={
						<BlockRoundButton onClick={nextStep}>
							{renderLabel({
								icon: <FireOutlined />,
								label: t('onboarding:checkpoint2.action'),
								extra: <RightOutlined />,
							})}
						</BlockRoundButton>
					}
				/>
			</Card>
		</ContentWrapper>
	</SectionWrapper>
)

export default OnboardingCheckpoint2
